import logger from '../../utils/logger';
import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { googleLogin } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Use useRef to prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash;
    const sessionIdMatch = hash.match(/session_id=([^&]+)/);

    const processAuth = async () => {
      if (sessionIdMatch) {
        const sessionId = sessionIdMatch[1];
        try {
          const user = await googleLogin(sessionId);
          // Clear the hash
          window.history.replaceState(null, '', window.location.pathname);
          
          if (user.role === 'admin') {
            navigate('/admin/dashboard', { replace: true });
          } else {
            navigate('/', { replace: true });
          }
        } catch (error) {
          logger.error('Auth callback error:', error);
          navigate('/admin/login', { replace: true });
        }
      } else {
        navigate('/admin/login', { replace: true });
      }
    };

    processAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- runs once on mount; useRef guard prevents re-execution
  }, []);

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 animate-spin text-[#BA1826] mx-auto mb-4" />
        <p className="text-[#4B5563]">Completing sign in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
